import * as Yup from 'yup';

export const editKioskValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  status: Yup.string().required('Status is required'),
  color: Yup.string().required('Color is required')
});

export const getEditKioskInitialValues = ({ kiosk, members }) => ({
  name: kiosk?.name,
  color: kiosk?.color,
  status: kiosk?.status,
  description: kiosk?.description,
  notify_users: members?.filter((practitioner) => kiosk?.notify_users?.includes(practitioner.value))
});
